// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__2P-Lk","question":"Question_question__2Fmd1","description":"Question_description__w3SQZ"};